import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import "./APartnerAgr.scss";
import { connect } from "react-redux";
import { customerService } from "../../services";
import QUESTION_UI from "./APartnerAgrQuestion";


const ASSET = {
    home: "/images/apartner/apartner-main.png",
    pass: "/images/apartner/mission-pass.png",
    question: "/images/apartner/apartner-main.png",
};



function APartnerAgr({ profile }) {
    // if (profile.length === 0) {
    //     window.location.replace("/APartner");
    // }



    const customerLS = useMemo(() => {
        try {
            const raw = localStorage.getItem("customer");
            return raw ? JSON.parse(raw) : null;
        } catch {
            return null;
        }
    }, []);

    const [screen, setScreen] = useState("home");
    const [passedMissionSet, setPassedMissionSet] = useState(new Set());
    const [currentMission, setCurrentMission] = useState(null);
    const [selectedMission, setSelectedMission] = useState(null);

    const [amwayNumber, setAmwayNumber] = useState(null);
    const [partyId, setPartyId] = useState(null);

    const [passDigits, setPassDigits] = useState(["", "", "", ""]);
    const [missionPasswords, setMissionPasswords] = useState({ 1: [], 2: [], 3: [], 4: [], 5: [] });
    const [isCheckingPass, setIsCheckingPass] = useState(false);


    const [answers, setAnswers] = useState({});
    const [allCorrect, setAllCorrect] = useState(false);
    const [checked, setChecked] = useState(false);

    const passRefs = useRef([]);

    const [bgReady, setBgReady] = useState(false);
    const [pageReady, setPageReady] = useState(false);
    const [staffReady, setStaffReady] = useState(false);
    const [customerReady, setCustomerReady] = useState(false);
    const [passedReady, setPassedReady] = useState(false);
    const [passedFetched, setPassedFetched] = useState(false);

    const passCode = useMemo(() => passDigits.join(""), [passDigits]);
    const passComplete = useMemo(() => passDigits.every((d) => d !== ""), [passDigits]);

    const questions = QUESTION_UI[`station${currentMission}`] || [];
    const answeredAll3 = useMemo(
        () => questions.every((q) => !!answers[q.id]),
        [answers, questions]
    );
    const dataReady = staffReady && customerReady && passedReady;

    const resetPass = () => setPassDigits(["", "", "", ""]);

    const bgSrc = useMemo(() => {
        const map = {
            home: ASSET.home,
            pass: ASSET.pass,
            question: ASSET.question,
        };

        return map[screen] || ASSET.home;
    }, [screen]);

    useEffect(() => {
        let cancelled = false;

        const run = async () => {
            await new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));

            try {
                if (document.fonts?.ready) await document.fonts.ready;
            } catch { }

            if (!cancelled) setPageReady(true);
        };

        run();

        return () => {
            cancelled = true;
        };
    }, []);


    useEffect(() => {
        setBgReady(false);

        const img = new Image();
        img.onload = () => setBgReady(true);
        img.onerror = () => setBgReady(true);
        img.src = bgSrc;
    }, [bgSrc]);

    useEffect(() => {
        const el = document.getElementById("wrapper");
        if (!el) return;

        el.classList.add("apartner-full");

        return () => {
            el.classList.remove("apartner-full");
        };
    }, []);

    useEffect(() => {
        if (!passedFetched) return;
        setPassedReady(true);
    }, [passedFetched]);

    useEffect(() => {
        if (customerLS?.amwayNumber && !amwayNumber) setAmwayNumber(customerLS.amwayNumber);
        if (customerLS?.partyId && !partyId) setPartyId(customerLS.partyId);
    }, [customerLS, amwayNumber, partyId]);

    useEffect(() => {
        let cancelled = false;

        const fetchCustomer = async () => {
            if (profile == null) return;

            if (!profile?.userId) {
                if (!cancelled) setCustomerReady(true);
                return;
            }


            try {
                const c = await customerService.get(profile.userId);

                if (!c) window.location.replace("/APartner");

                if (!cancelled) {
                    setAmwayNumber(c.amwayNumber);
                    setPartyId(c.partyId);
                }

                const res = await axios.post(`${process.env.REACT_APP_API_URL}/customers/expo`, {
                    uid: c.uid,
                    amwayNumber: c.amwayNumber,
                    partyId: c.partyId,
                    type: "A",
                });

                const logs = Array.isArray(res.data?.customerLog) ? res.data.customerLog : [];

                const hasMAll = logs.some((l) => String(l.type || "").toUpperCase() === "AALL");

                if (hasMAll) {
                    window.location.replace("/APartner");
                    return;
                }

                const nextSet = new Set();

                logs.forEach((l) => {
                    const t = String(l.type || "").toUpperCase();

                    if (t.startsWith("A")) {
                        const no = Number(t.replace("A", ""));

                        if (!Number.isNaN(no)) {
                            nextSet.add(no);
                        }
                    }
                });

                if (!cancelled) {
                    setPassedMissionSet(nextSet);
                    setPassedFetched(true);
                }

                if (!staffReady) {
                    try {
                        const staffRes = await axios.post(`${process.env.REACT_APP_API_URL}/customers/expo_staff`, {});
                        const rows = Array.isArray(staffRes.data) ? staffRes.data : [];

                        const temp = { 1: [], 2: [], 3: [], 4: [], 5: [] };

                        rows.forEach((r) => {
                            const type = String(r.type || "").toLowerCase();
                            const clean = String(r.amwayNumber || "").replace(/\D/g, "");

                            if (clean.length !== 4) return;

                            if (type === "a1") temp[1].push(clean);
                            if (type === "a2") temp[2].push(clean);
                            if (type === "a3") temp[3].push(clean);
                            if (type === "a4") temp[4].push(clean);
                            if (type === "a5") temp[5].push(clean);
                        });

                        if (!cancelled) setMissionPasswords(temp);
                    } catch (e) {
                        console.error("fetchStaff error", e);
                    } finally {
                        if (!cancelled) setStaffReady(true);
                    }
                }
            } catch (e) {
                console.error("fetchCustomer error", e);
            } finally {
                if (!cancelled) setCustomerReady(true);
            }
        };

        fetchCustomer();

        return () => {
            cancelled = true;
        };
    }, [profile?.userId]);

    const onClickMission = (missionNo) => {
        setCurrentMission(missionNo);

        setAnswers({});
        setChecked(false);
        setAllCorrect(false);

        resetPass();
        setScreen("question");
    };

    const onClickฺBack = () => {
        setCurrentMission("");

        setAnswers({});
        setChecked(false);
        setAllCorrect(false);

        resetPass();
        setScreen("home");
    };

    const onPassChange = (idx, raw) => {
        const v = (raw || "").replace(/\D/g, "").slice(-1);

        setPassDigits((prev) => {
            const next = [...prev];
            next[idx] = v;
            return next;
        });

        if (v && idx < 3) {
            setTimeout(() => passRefs.current?.[idx + 1]?.focus?.(), 0);
        }
    };

    const onPassKeyDown = (idx, e) => {
        if (e.key === "Backspace" && !passDigits[idx] && idx > 0) {
            setTimeout(() => passRefs.current?.[idx - 1]?.focus?.(), 0);
        }
    };

    const goNextToQuestion = async () => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/customers/expo`, {
                uid: profile.userId,
                amwayNumber,
                partyId,
                type: "A",
            });

            const logs = Array.isArray(res.data?.customerLog)
                ? res.data.customerLog
                : [];

            const hasAllMission = ["A1", "A2", "A3", "A4", "A5"].every((t) =>
                logs.some((x) => String(x.type || "").toUpperCase() === t)
            );

            if (!hasAllMission) return;

            await axios.post(`${process.env.REACT_APP_API_URL}/customers/expo_pass`, {
                uid: profile.userId,
                amwayNumber,
                partyId,
                type: "AAll",
            });

            window.location.replace("/APartner");
        } catch (e) {
            console.error("goNextToQuestion error", e);
        }
    };
    useEffect(() => {
        document.body.classList.add("apartner-body");
    }, []);

    useEffect(() => {
        if (!answeredAll3) {
            setChecked(false);
            setAllCorrect(false);
            return;
        }

        const everyCorrect = questions.every(
            (q) => answers[q.id] === q.answer
        );

        setChecked(true);
        setAllCorrect(everyCorrect);
    }, [answeredAll3, answers, questions]);

    const onSelectChoice = (qId, choiceId) => {
        // if (checked) return;

        setAnswers((prev) => ({
            ...prev,
            [qId]: choiceId,
        }));
    };

    const handleSubmitAnswer = async () => {
        if (!answeredAll3) return;
        if (!checked) return;

        if (!allCorrect) {
            setChecked(false);
            setAllCorrect(false);
            setAnswers({});
            return;
        }

        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/customers/expo_pass`, {
                uid: profile.userId,
                amwayNumber,
                partyId,
                type: `A${currentMission}`,
            });
            setPassedMissionSet((prev) => {
                const next = new Set(prev);
                next.add(currentMission);
                return next;
            });

            setAnswers({});
            setChecked(false);
            setAllCorrect(false);

            setScreen("home");
        } catch (e) {
            console.error("submit mission answer error", e);
        }
    };

    const lockCards = passedMissionSet.size === 5;

    return (
        <div className={`APartnerAgr ${pageReady && bgReady && dataReady ? "loaded" : ""}`}>
            <div className={`apartner-missionPage screen-${screen}`}>
                {(!pageReady || !bgReady || !dataReady) && <div className="bgLoading" />}

                <img
                    className="missionImg"
                    src={bgSrc}
                    alt="mission"
                    style={{
                        opacity: pageReady && bgReady && dataReady ? 1 : 0,
                        transition: "opacity .25s ease",
                    }}
                />

                {pageReady && dataReady && (
                    <>
                        {screen === "home" && passedReady && (
                            <div className={`homeOverlay ${!passedReady ? "disabled" : ""}`}>
                                <div className="missionGrid">
                                    {[1, 2, 3, 4, 5].map((no) => (
                                        <button
                                            key={no}
                                            className={`APartnerCard ${passedMissionSet.has(no) ? "done" : ""}`}
                                            onClick={() => !lockCards && onClickMission(no)}
                                            type="button"
                                            disabled={passedMissionSet.has(no) ? "disabled" : ""}

                                        >
                                            <div className="APartnerCardHeader">ฐาน</div>

                                            <div className="APartnerCardBody">
                                                <div className="APartnerNumberCircle">
                                                    {passedMissionSet.has(no) ? (
                                                        <>
                                                            <img
                                                                src="/images/apartner/apartner-A.png"
                                                                alt="A Partner"
                                                                className="APartnerDoneImage"
                                                            />
                                                            <div className="APartnerDoneText">สำเร็จแล้ว</div>
                                                        </>
                                                    ) : (
                                                        no
                                                    )}
                                                </div>
                                            </div>
                                        </button>
                                    ))}
                                </div>

                                {passedMissionSet.size === 5 && (
                                    <div className="missionNextWrapper">
                                        <button
                                            className="missionApartnerNextBtn"
                                            onClick={goNextToQuestion}
                                            type="button"
                                        >
                                            รับของที่ระลึก
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}

                        {(screen === "pass") && selectedMission && (
                            <div className="missionInfoOverlay">
                                <div className="missionInfoCode">{selectedMission.code}</div>

                                <img
                                    className="missionInfoIcon"
                                    src={selectedMission.icon}
                                    alt={selectedMission.code}
                                />

                                <div className="missionInfoTitle">{selectedMission.title}</div>
                            </div>
                        )}

                        {(screen === "pass") && (
                            <div className="apartnercodeAgrPanel">
                                <div className="apartnercodeAgrRow">
                                    {passDigits.map((v, idx) => (
                                        <input
                                            key={idx}
                                            ref={(el) => {
                                                passRefs.current[idx] = el;
                                            }}
                                            className="apartnerCodeInput"
                                            inputMode="numeric"
                                            value={v}
                                            onChange={(e) => onPassChange(idx, e.target.value)}
                                            onKeyDown={(e) => onPassKeyDown(idx, e)}
                                            maxLength={1}
                                            type="password"
                                        />
                                    ))}
                                </div>
                            </div>
                        )}

                        {screen === "question" && (
                            <div className="questionOverlay" onClick={(e) => e.stopPropagation()}>
                                <div className="apartnerBack" onClick={onClickฺBack}>‹</div>
                                <div className={`apartner-questionCard ${checked && !allCorrect ? "wrong" : !answeredAll3 ? "" : "correct"}`}>
                                    <div className="apartnerBoothBadge">
                                        ฐาน#{currentMission}
                                    </div>

                                    {QUESTION_UI[`station${currentMission}`]?.map((q) => (
                                        <div key={q.id} className="apartner-qBlock">
                                            <div className="apartner-qTitle">{q.title}</div>
                                            <div className="apartner-qDesc">{q.desc}</div>

                                            <div className="apartner-qOptions">
                                                {q.options.map((op) => {
                                                    const selected = answers[q.id] === op.id;

                                                    return (
                                                        <button
                                                            key={op.id}
                                                            type="button"
                                                            // disabled={checked}
                                                            className={`apartner-qOpt
                                                                ${selected ? "selected" : ""}
                                                                ${checked && selected &&
                                                                    allCorrect &&
                                                                    answers[q.id] === q.answer
                                                                    ? "correct"
                                                                    : ""
                                                                }
                                                                
                                                                ${checked &&
                                                                    !allCorrect &&
                                                                    selected &&
                                                                    answers[q.id] !== q.answer
                                                                    ? "wrong"
                                                                    : ""
                                                                }
                                                            `}
                                                            onClick={() => onSelectChoice(q.id, op.id)}
                                                        >
                                                            <div className="apartner-qOptLabel">
                                                                {op.label}
                                                            </div>
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <button
                                    type="button"
                                    className={`
                                        selectAPAnswerBtn
                                        ${answeredAll3 ? "enabled" : "disabled"}
                                        ${checked && !allCorrect ? "wrong" : ""}
                                        ${checked && allCorrect ? "correct" : ""}
                                    `}
                                    disabled={!answeredAll3}
                                    onClick={handleSubmitAnswer}
                                >
                                    {!checked && "กรุณาเลือกคำตอบ"}
                                    {checked && !allCorrect && "มีคำตอบที่ไม่ถูกต้อง"}
                                    {checked && allCorrect && "ยืนยัน"}
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div >
    );
}

export default connect((s) => ({ profile: s.profile }))(APartnerAgr);